import { render, staticRenderFns } from "./ListOnSchemaEditor.vue?vue&type=template&id=0079d63a&scoped=true&"
import script from "./ListOnSchemaEditor.vue?vue&type=script&lang=js&"
export * from "./ListOnSchemaEditor.vue?vue&type=script&lang=js&"
import style0 from "./ListOnSchemaEditor.vue?vue&type=style&index=0&id=0079d63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0079d63a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
